import type React from 'react';

import { StaffDrawer, StaffDrawerInfo, StaffDrawerLink, StaffDrawerSection } from '#src/app/shared/components/staff';

import { usePetitionUpdateStaffDrawer } from './hooks/usePetitionUpdateStaffDrawer';

export const PetitionUpdateStaffDrawer: React.FC<EmptyProps> = () => {
	const {
		data: { updateId, kind, createdAt, authorId, decisionMakerId, petitionId, status, promotable, starterId, urls },
	} = usePetitionUpdateStaffDrawer();

	return (
		<StaffDrawer>
			<StaffDrawerSection title="Update">
				<StaffDrawerInfo label="Update ID" value={updateId} copyable />
				<StaffDrawerInfo label="Kind" value={kind} />
				<StaffDrawerInfo label="Created" value={createdAt} />
				<StaffDrawerLink href={urls.editUpdate}>Edit update</StaffDrawerLink>
				<StaffDrawerLink href={urls.updateModeration}>Update moderation</StaffDrawerLink>
				<StaffDrawerLink href={urls.updateEmailLimits}>Update email limits</StaffDrawerLink>
			</StaffDrawerSection>
			{authorId && urls.authorAdmin && (
				<StaffDrawerSection title="Author">
					<StaffDrawerInfo label="User ID" value={authorId} copyable />
					<StaffDrawerLink href={urls.authorAdmin}>User admin</StaffDrawerLink>
				</StaffDrawerSection>
			)}
			{decisionMakerId && urls.decisionMakerAdmin && (
				<StaffDrawerSection title="Decision maker">
					<StaffDrawerInfo label="DM ID" value={decisionMakerId} copyable />
					<StaffDrawerLink href={urls.decisionMakerAdmin}>DM admin</StaffDrawerLink>
				</StaffDrawerSection>
			)}
			<StaffDrawerSection title="Petition">
				<StaffDrawerInfo label="Petition ID" value={petitionId} copyable />
				<StaffDrawerInfo label="Status" value={status} />
				<StaffDrawerInfo label="Promotable" value={promotable} />
				<StaffDrawerLink href={urls.petitionAdmin}>Petition admin</StaffDrawerLink>
				<StaffDrawerLink href={urls.dashboard}>Dashboard</StaffDrawerLink>
			</StaffDrawerSection>
			<StaffDrawerSection title="Starter">
				<StaffDrawerInfo label="User ID" value={starterId} copyable />
				<StaffDrawerLink href={urls.starterAdmin}>User admin</StaffDrawerLink>
			</StaffDrawerSection>
		</StaffDrawer>
	);
};
